import { render, staticRenderFns } from "./Page-Menu.vue?vue&type=template&id=76db00ce&"
import script from "./Page-Menu.vue?vue&type=script&lang=js&"
export * from "./Page-Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports